import { FC } from "react";
import {
  BinSelectedInfo,
  LocationGrainTrackerValues,
  LocationSelectedIs,
  PrincipalInfoGT,
  SelectedLocation,
} from "../../../../redux/slices/grainTracker/grainTrackerTypes";

import { LocationSelectedDetails } from "../../../../redux/actions/locations/locationsTypes";
import { NavigateFunction } from "react-router-dom";
import FirstMenuLocationDetails from "./menuParts/firstMenuLocationDetails";
import SecondMenuLocationDetails from "./menuParts/secondMenuLocationDetails";
import ThirdMenuLocationDetails from "./menuParts/thirdMenuLocationDetails";

type LocationDetailsMenuParams = {
  t: (arg0: string) => string;
  locationSelectedDetails: any;
  navigate: NavigateFunction;
  totalUsersInlocation: number;
  sharedLocation: number;
  capacity: number;
  redirectToEditLocation: (
    selectedLocation: SelectedLocation,
    navigate: NavigateFunction,
    locationSelectedIs: { EditingStockage: boolean; EditingValues: boolean },
  ) => void;
  locationGrainTrackerValues: LocationGrainTrackerValues;
  locationSelectedIs: LocationSelectedIs;
  selectedLocation: SelectedLocation;
  isBinSelected: boolean;
  selectedBin: {
    values: undefined | BinSelectedInfo;
    loading: boolean;
    error: string;
  };
  isLocationShared: boolean;
  successShareDeleteBins: boolean;
  resetBin: () => void;
  redirectToEditStorage: (
    selectedLocation: LocationSelectedDetails,
    navigate: NavigateFunction,
    locationSelectedIs: {
      EditingStockage: boolean;
    },
    graintrackerValues: LocationGrainTrackerValues,
  ) => void;
  setInformationByClicking: (
    binInformation: any,
    principalInfoGT: PrincipalInfoGT,
    principalInfoGTCopy: PrincipalInfoGT,
    token: string,
  ) => void;
  setSelectedSiteToShare: (
    navigate: NavigateFunction,
    selectedSiteToShare: {
      name: string;
      id: string;
    },
  ) => void;
  resetSingleLocationState: () => void;
  locationInfoFromTable:
    | {
        name: string;
        id: string;
        address: string;
        capacity: number;
        longitude: number;
        latitude: number;
      }
    | undefined;
};

const LocationDetailsMenu: FC<LocationDetailsMenuParams> = ({
  t,
  locationSelectedDetails,
  navigate,
  totalUsersInlocation,
  sharedLocation,
  capacity,
  redirectToEditLocation,
  locationGrainTrackerValues,
  locationSelectedIs,
  selectedLocation,
  isBinSelected,
  selectedBin,
  isLocationShared,
  successShareDeleteBins,
  resetBin,
  redirectToEditStorage,
  setSelectedSiteToShare,
  resetSingleLocationState,
  setInformationByClicking,
  locationInfoFromTable,
}) => {
  return (
    <div className="location-details-view">
      <FirstMenuLocationDetails
        navigate={navigate}
        t={t}
        resetSingleLocationState={resetSingleLocationState}
        isBinSelected={isBinSelected}
        locationSelectedDetails={locationSelectedDetails}
        selectedBin={selectedBin}
        resetBin={resetBin}
        locationInfoFromTable={locationInfoFromTable}
      />
      <SecondMenuLocationDetails
        t={t}
        setInformationByClicking={setInformationByClicking}
        isLocationShared={isLocationShared}
        isBinSelected={isBinSelected}
        locationSelectedDetails={locationSelectedDetails}
        selectedBin={selectedBin}
        redirectToEditLocation={redirectToEditLocation}
        navigate={navigate}
        locationSelectedIs={locationSelectedIs}
        locationGrainTrackerValues={locationGrainTrackerValues}
        redirectToEditStorage={redirectToEditStorage}
        capacity={capacity}
        selectedLocation={selectedLocation}
        successShareDeleteBins={successShareDeleteBins}
        setSelectedSiteToShare={setSelectedSiteToShare}
        locationInfoFromTable={locationInfoFromTable}
      />

      {!isBinSelected ? (
        <ThirdMenuLocationDetails
          t={t}
          navigate={navigate}
          locationSelectedDetails={locationSelectedDetails}
          totalUsersInlocation={totalUsersInlocation}
          sharedLocation={sharedLocation}
          capacity={capacity}
          locationInfoFromTable={locationInfoFromTable}
        />
      ) : (
        ""
      )}
    </div>
  );
};

export default LocationDetailsMenu;
